import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import CustomCard from '../../../components/CustomCard';
import Form from '../../../components/form/Form';
import fields from '../../customer/CustomerFormConfig';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import SearchCustomer from '../../customer/SearchCustomer';
import { Actions } from '../../../../client/Actions';
import LightButton from '../../../components/button/LightButton';
import TrickButton from '../../../components/button/TrickButton';

const CustomerSection = ({
  customer,
  setCustomer,
  formKey,
  setFormKey,
  onCancel,
  onSave,
  withoutNew,
  setNewCustomerReady,
}) => {
  const [openSearchClient, setOpenSearchClient] = useState(null);

  useEffect(() => {
    if (customer && openSearchClient) {
      setOpenSearchClient(false);
    }
  }, [customer]);

  return (
    <>
      <CustomCard
        md={12}
        shadow={false}
        title={
          <div className="d-flex justify-content-between align-items-center">
            <h3>
              Dane klienta{' '}
              <TrickButton text="Jeśli klient jest nowy, wpisz jego dane – system automatycznie doda go do bazy przy tworzeniu rezerwacji. Jeśli klient już wcześniej rezerwował, skorzystaj z przycisku „Wyszukaj klienta”, aby uniknąć duplikatów." />
              {customer?.id && (
                <>
                  {' '}
                  <TrickButton
                    variant={'outline-warning'}
                    color={'#ffc107'}
                    text="Obecnie pracujesz na danych istniejącego klienta. Kliknij „Zmień”, aby edytować jego dane w bazie, lub „Resetuj”, aby wybrać innego lub dodać nowego klienta."
                  />
                </>
              )}
            </h3>
            <div className="d-flex justify-content-end align-items-center gap-3">
              {!withoutNew && (
                <LightButton
                  onClick={() => {
                    setFormKey(Date.now());
                    setCustomer(null);
                  }}
                >
                  Resetuj
                </LightButton>
              )}
              <Button
                onClick={() => setOpenSearchClient(true)}
                variant="primary"
              >
                Wyszukaj klienta
              </Button>
              {onCancel && (
                <Button variant={'outline-secondary'} onClick={onCancel}>
                  Anuluj
                </Button>
              )}
              {onSave && (
                <Button variant={'success'} onClick={onSave}>
                  Zapisz
                </Button>
              )}
            </div>
          </div>
        }
      >
        {!customer?.id ? (
          <Form
            title="Nowy klient"
            className="border-top pt-3"
            shadow={false}
            key={formKey}
            fields={fields}
            width={12}
            formDataChanged={setCustomer}
            noActions={true}
            onReadyUpdate={setNewCustomerReady}
          />
        ) : (
          <Form
            shadow={false}
            key={formKey + customer?.id}
            title="Klient"
            api="customer"
            fields={fields}
            editable={!!customer}
            initialData={customer}
            readOnly={!!customer}
            width={12}
            reInit={() => {
              setCustomer(undefined);
              Actions.get('customer/' + customer?.id, (data) => {
                setCustomer(data);
                setFormKey(Date.now());
              });
            }}
            editApi={`customer/${customer?.id}`}
            saveButton={!!customer ? 'Edytuj' : 'Dodaj'}
          />
        )}
      </CustomCard>

      <ConfirmModal
        title="Wyszukaj klienta"
        show={openSearchClient}
        size={'xl'}
        setShow={setOpenSearchClient}
        fullscreen={false} // ✅ Fullscreen on all breakpoints
        buttonsConf={{ cancel: 'Anuluj' }}
        withoutConfirm={true}
        children={<SearchCustomer selectCustomer={setCustomer} />}
      />
    </>
  );
};

export default CustomerSection;
